// src/components/LanguageSwitcher.tsx
import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { C } from "../theme";

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div style={s.container}>
      <button
        onClick={() => setLanguage("en")}
        style={{
          ...s.btn,
          ...(language === "en" ? s.active : s.inactive),
        }}
      >
        EN
      </button>
      <button
        onClick={() => setLanguage("ka")}
        style={{
          ...s.btn,
          ...(language === "ka" ? s.active : s.inactive),
        }}
      >
        ქარ
      </button>
    </div>
  );
};

const s: Record<string, React.CSSProperties> = {
  container: {
    display: "flex",
    gap: "2px",
    backgroundColor: C.surface2,
    border: `1px solid ${C.border}`,
    borderRadius: "40px",
    padding: "2px",
  },
  btn: {
    border: "none",
    borderRadius: "40px",
    padding: "5px 14px",
    fontSize: "12px",
    fontWeight: 600,
    cursor: "pointer",
    transition: "all 0.15s",
    fontFamily: "inherit",
  },
  active: {
    backgroundColor: C.red,
    color: C.onAccent,
  },
  inactive: {
    backgroundColor: "transparent",
    color: C.text2,
  },
};

export default LanguageSwitcher;
